module.exports = __webpack_public_path__ + "static/media/logo_reservando_word.34e1245b.png";